import { withDonorAuth } from '~/hocs/with-donor-auth'
import { withStripe } from '~/hocs/with-stripe'
import { DonorPortal } from '~/pages/donor-portal/pages/home'

export default withStripe(withDonorAuth(DonorPortal))
